<template>
  <div class="gem-container">
    <div @click="openStore" class="gems">
      <span>{{ creditLabel }}</span>
      <img
        class="plus"
        src="../../assets/images/navbar/green-plus.svg"
        alt="plus"
      />
    </div>
    <img
      class="messages"
      src="../../assets/images/icons/messages.svg"
      alt="messages"
      @click="openInstaproMessages"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import { CURRENCY_TYPES } from "@/store/user/inventory/inventory.constants"
import { convertPointToPrice, convertPbCreditToUsd, formatPriceUSD } from "@/store/utils/util.utils"

export default {
  computed: {
    ...mapGetters("User/Inventory", [
      "getPGPoints",
      "getPbCredit",
      "getPrimaryCreditCurrency",
    ]),
    ...mapGetters("Message", ["collapsed"]),
    creditInUsd () {
      switch (this.getPrimaryCreditCurrency) {
        case CURRENCY_TYPES.PG_POINTS:
          return convertPointToPrice(this.getPGPoints)
        case CURRENCY_TYPES.PB_CREDIT:
          return convertPbCreditToUsd(this.getPbCredit)
        default:
          return 0
      }
    },
    creditLabel () {
      return formatPriceUSD(this.creditInUsd)
    },
  },
  methods: {
    ...mapActions("User/Inventory", ["loadInventory"]),
    ...mapMutations("Message", ["setCollapsed"]),
    ...mapMutations("Util", [
      "setNavbarDrawerShowing",
      "setPageLoading",
      "setShowGameContainer",
    ]),
    openInstaproMessages () {
      this.setCollapsed(!this.collapsed)
      // const openInstaproMessagesEvent = new CustomEvent("instaproEvent", {
      //   detail: {
      //     eventType: "openInstaproMessages",
      //   },
      // })
      // document.dispatchEvent(openInstaproMessagesEvent)
    },
    async openStore () {
      const path = "/store/points"
      this.setShowGameContainer(false)
      this.setNavbarDrawerShowing(false)
      this.setPageLoading(true)
      if (this.$route.path !== path) {
        await this.$router.push(path)
      }
      this.setPageLoading(false)
    },
  },
  created () {
    this.loadInventory()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.gem-container {
  margin-left: 2rem;
  font-family: $font-display;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 110%;
  transition: color 0.2s ease-in;
  color: #01b4ff;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  .gems {
    display: flex;
    align-items: center;
    .gem {
      margin-left: 1rem;
      width: 1.5rem;
      height: 1.5rem;
    }
    .plus {
      position: absolute;
      right: -0.8rem;
      bottom: 0;
      opacity: 0;
      transition: opacity 0.2s ease-in;
      @include desktop-down {
        display: none;
      }
    }
  }
  .messages {
    display: none;
    @include desktop-down {
      display: block;
      margin-left: 3rem;
    }
  }
  &:hover {
    color: #fff;
    .plus {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/GemContainer.vue